import { QUERY_KEYS } from 'api/query-keys';
import { useSiteDetection } from 'shared/hooks';
import { sharedWorkersService } from 'api/services';
import { useQuery } from 'react-query';

export const useGetWorkersForSelect = (search: string) => {
  const { site } = useSiteDetection();
  const query = useQuery({
    queryKey: QUERY_KEYS.workerList(search),
    queryFn: async () => await sharedWorkersService.getWorkerList(search, site),
    enabled: search.length > 2,
  });

  return query;
};
